<template>
  <div>
    <div class="content_header">
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate color="amber"></v-progress-circular>
      </v-overlay>

      <v-toolbar flat color="white mx-2">
        <v-toolbar-title>新作アプリカレンダー</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>

        <a
          target="_blank"
          href="http://test.dev-appmedia.xyz/atelier-online/499753"
          >確認用(テスト)http://test.dev-appmedia.xyz/atelier-online/499753</a
        >

        <v-spacer></v-spacer>

        <dialogLabel
          :show_btn="false"
          ref="categoryDialog"
          @itemUpdate="itemUpdate"
          @itemCreate="itemCreate"
        ></dialogLabel>

        <editCategory
          :show_btn="false"
          ref="editCategory"
          @categoryUpdate="categoryUpdate"
        ></editCategory>

        <editArticleList
          :show_btn="false"
          ref="sortArticleList"
          @sortArticleUpdate="sortArticleUpdate"
        ></editArticleList>

        <div v-if="honban_flg == true">
          <span style="font-weight:bold;font-size:14px;color:red"
            >※変更後のデータが本番環境に反映されていません。</span
          >
        </div>

        <v-btn color="primary" dark class="mb-2" @click="confirm_dialog = true"
          >テスト反映</v-btn
        >
        <v-dialog v-model="confirm_dialog" persistent max-width="290">
          <v-card>
            <v-card-title class="text-h5">
              CSVアップロード確認
            </v-card-title>
            <v-card-text>データを本番環境に適用します。</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                text
                @click="confirm_dialog = false"
              >
                キャンセル
              </v-btn>
              <v-btn color="green darken-1" text @click="apply()">
                OK
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          id="data_search"
          class="mx-4 pa-4"
          placeholder="検索"
          clearable
        ></v-text-field> -->

        <v-dialog v-model="dialog" max-width="1100px" class="ma-0" persistent>
          <v-card>
            <v-card-title>
              <span class="headline">データ登録</span>

              <v-divider class="mx-2" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="primary" dark @click="save(editedItem)"
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card-title>

            <v-card-text>
              <v-container class="pa-4">
                <v-form ref="form_check">
                  <v-row class="pa-0">
                    <v-col cols="6">
                      カテゴリ<Br />
                      <v-combobox
                        :items="category_list"
                        v-model="editedItem.category"
                        solo
                        hide-details=""
                        outlined
                        flat
                      >
                        <template slot="selection" slot-scope="{ item }">
                          <span :class="{ disable_item: item.delete_flg == 1 }">
                            {{ item.title }}
                          </span>
                        </template>
                        <template slot="item" slot-scope="{ item }">
                          <span :class="{ disable_item: item.delete_flg == 1 }">
                            {{ item.title }}
                          </span>
                        </template>
                      </v-combobox></v-col
                    >

                    <v-col cols="6">
                      <v-text-field
                        v-model="editedItem.release"
                        label="リリース日"
                        hide-details=""
                        class="pt-8"
                        :rules="[required]"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="6">
                      <v-text-field
                        v-model="editedItem.title"
                        label="タイトル名"
                        :rules="[required]"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="6">
                      <v-text-field
                        v-model="editedItem.sub_title"
                        label="タイトル略称"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="6">
                      <v-text-field
                        v-model="editedItem.link"
                        label="事前登録記事link"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="6">
                      <v-text-field
                        v-model="editedItem.publisher"
                        label="開発・運営"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="6">
                      <v-textarea
                        v-model="editedItem.desc"
                        label="説明"
                        rows="2"
                      ></v-textarea>
                    </v-col>

                    <v-col cols="6">
                      <v-text-field
                        v-model="editedItem.precede_report"
                        label="先行プレイ記事(任意)"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="6">
                      <div
                        class="img_preview"
                        @click="scaleImg(uploadImageUrl1)"
                      >
                        <img
                          :src="
                            uploadImageUrl1 ||
                              'https://appmedia.jp/wp-content/uploads/9999/10/6e251bb8086c67330b8a7d878a4af1b9.png'
                          "
                        />
                      </div>
                      <v-form ref="form">
                        <v-file-input
                          v-model="input_image"
                          accept="image/*"
                          multiple
                          show-size
                          label="画像アイコン"
                          prepend-icon="mdi-image"
                          @change="onImagePicked"
                        ></v-file-input>
                      </v-form>
                    </v-col>

                    <v-col cols="6">
                      <v-text-field
                        v-model="editedItem.play_movie"
                        label="先行プレイ動画(任意)"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </div>

    <v-card class="ma-2 pa-2" dense>
      <v-row class="ml-5">
        <v-col cols="4">
          <v-select
            v-model="select_category"
            :items="category_list"
            item-text="title"
            item-value="id"
            outlined
            hide-details=""
            return-object
            dense
            style="text-align: left;"
            @change="listchange"
          >
            <template slot="selection" slot-scope="{ item }">
              <span :class="{ disable_item: item.delete_flg == 1 }">
                {{ item.title }}
              </span>
            </template>
            <template slot="item" slot-scope="{ item }">
              <span :class="{ disable_item: item.delete_flg == 1 }">
                {{ item.title }}
              </span>
            </template>
          </v-select>
        </v-col>
        <v-col cols="4">
          <v-btn @click="newDialog" outlined>カテゴリを新規追加</v-btn>

          <v-btn @click="editDialog" outlined class="ml-1"
            >カテゴリを編集</v-btn
          >
        </v-col>

        <v-col cols="2">
          <v-btn @click="editAriticleSortDialog" outlined class="ml-1"
            >記事の並び替え</v-btn
          >
        </v-col>

        <v-col cols="2" style="text-align: right;">
          <v-btn color="primary" dark class="mb-2" @click="newItem()" outlined
            >+ 作品を新規追加</v-btn
          >
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="list"
        :search="search"
        :items-per-page="50"
        :footer-props="{ itemsPerPageOptions: [50, 100] }"
      >
        <template v-slot:item="{ item }">
          <tr
            :class="{
              public_item: item.status.id == 1,
            }"
          >
            <td class="center">
              <v-icon small color="primary" @click="editItem(item)"
                >fas fa-edit</v-icon
              >
            </td>
            <td class="center">{{ item.sort }}</td>

            <td>{{ item.release }}</td>

            <td>{{ item.title }}</td>

            <td class="pa-1">
              <div v-if="item.question_id == 0">
                <v-btn @click="getQuestion(item)">アンケート取得(-)</v-btn>
              </div>
              <div v-else>
                <v-btn @click="getQuestion(item)"
                  >アンケート取得[{{ item.question_id }}]</v-btn
                >
              </div>
            </td>

            <td>
              <v-select
                :class="{
                  status_box: 1,
                  saving: item.status.id == 0 ? 1 : 0,
                  public: item.status.id == 1,
                }"
                :items="status_list"
                v-model="item.status"
                item-text="name"
                item-value="id"
                return-object
                hide-details=""
                @change="changeStatus(item)"
              >
              </v-select>
            </td>
          </tr>
        </template>

        <!--       
        <template v-slot:item.category="{ item }">
          <div @click="editItem(item)" text>
            {{ item.category ? item.category.title : "" }}
          </div>
        </template>

        <template v-slot:item.title="{ item }">
          <div @click="editItem(item)" text>{{ item.title }}</div>
        </template>

        <template v-slot:item.memo="{ item }">
          <div @click="editItem(item)" text>-</div>
        </template>

        <template v-slot:item.source="{ item }">
          <div @click="editItem(item)" text style="text-transform: none">
            {{ item.source }}
          </div>
        </template>

        <template v-slot:item.edit="{ item }">
          <v-icon small color="primary" @click="editItem(item)"
            >fas fa-edit</v-icon
          >
        </template>

        <template v-slot:item.status="{ item }">
          <v-select
            :class="{
              status_box: 1,
              saving: item.status.id == 0 ? 1 : 0,
              public: item.status.id == 1,
            }"
            :items="status_list"
            v-model="item.status"
            item-text="name"
            item-value="id"
            return-object
            hide-details=""
          >
          </v-select>
        </template> -->
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
// Ajax通信ライブラリ
import axios from "axios";

import dialogLabel from "@/components/dialogLabel";
import editCategory from "@/components/editCategory";
import editArticleList from "@/components/editArticleList";

export default {
  components: {
    dialogLabel,
    editCategory,
    editArticleList,
  },
  data() {
    return {
      dialog: false,
      confirm_dialog: false,
      overlay: false,

      select_category: {},

      category_list: [],

      status_list: [
        { id: "0", name: "保存中" },
        { id: "1", name: "公開" },
      ],

      honban_flg: false,

      //新アイテム
      editedItem: {
        id: -1,
        category: "",
        title: "",
        sub_title: "",
        link: "",
        publisher: "",
        desc: "",
        precede_report: "",
        play_movie: "",
        img: "",
        status: 0,
      },

      // //検索用パラメータ
      search: "",
      // height: 0,
      // dialog: false,
      headers: [
        {
          text: "編集",
          value: "edit",
          width: "60px",
          align: "center",
          sortable: false,
        },

        {
          text: "id",
          value: "sort",
          width: "44px",
          align: "center",
          sortable: false,
        },

        {
          text: "リリース日",
          value: "release",
          width: "160px",
          sortable: false,
        },

        { text: "タイトル名", value: "title", width: "300px", sortable: false },

        {
          text: "アンケート",
          value: "question_id",
          width: "100px",
          sortable: false,
        },

        { text: "フラグ", value: "status", width: "80px", sortable: false },

        // { text: "", value: "memo", width: "20px", fixed: true },
        // { text: "source", value: "source", width: "114px",align: "left", fixed: true },
        // { text: "編集", value: "edit", width: "60px" }
      ],
      list: [],
      // editedIndex: -1,
      // // editedItem: {
      // //   id: "",
      // //   category: "",
      // //   title: "",
      // //   source: "",
      // //   memo: "",
      // //   img_count: 0,
      // //   imageData1: "",
      // //   imageData2: ""
      // // },
      // //画像系
      // input_video: null,
      input_image: null,
      // uploadImageUrl_scallview: "",
      uploadImageUrl1: "",
      // uploadImageUrl2: "",

      // //画像拡大用
      // imgDialog: false,

      // // 入力規則
      required: (value) => !!value || "必ず入力してください", // 入力必須の制約
    };
  },

  computed: {
    //カテゴリフィルター
    // filteredItems() {
    //   return this.list.filter((i) => {
    //     if (i.category && this.select_category) {
    //       return i.category == this.select_category;
    //     } else {
    //       return false;
    //     }
    //   });
    // },
  },

  methods: {
    itemUpdate() {
      alert("up");
    },
    itemCreate(item) {
      this.category_list.unshift(item);

      this.editedItem.category = item;
    },

    //新規ダイアログ表示
    newDialog() {
      this.$refs.categoryDialog.newItem();
    },
    //更新ダイアログ表示
    // editDialog(item) {
    //   this.editedIndex = this.items.indexOf(item);
    //   this.$refs.categoryDialog.editItem(item);
    // },

    //編集ダイアログ表示
    editDialog() {
      this.$refs.editCategory.newItem(this.category_list);
    },

    //記事ソートダイアログ表示
    editAriticleSortDialog() {
      // console.log("before", this.filteredItems[0].title);

      this.$refs.sortArticleList.newItem(this.list);
    },

    categoryUpdate(data) {
      this.category_list = data;
    },

    sortArticleUpdate(data) {
      console.log("ater", data);
      this.list = data;
      // this.filteredItems = data;
      // console.log("ater", this.filteredItems);
    },

    deleteImg() {
      this.uploadImageUrl1 = "";
      this.uploadImageUrl2 = "";
      this.editedItem.imageData1 = "";
      this.editedItem.imageData2 = "";
      this.editedItem.img_count = 0;
    },

    //画像の読み込み
    onImagePicked(file) {
      if (this.input_image == null || this.input_image == "") {
        // this.uploadImageUrl1 = "";
        // this.editedItem.imageData1 = "";
        // this.editedItem.img_count = 0;
        return false;
      }

      var img_size = file.length;
      //今回は1ファイルのみ
      if (img_size > 1) {
        alert("画像のアップロードは1ファイルまで");
        return;
      }

      if (file == null || file.length == 0) {
        return false;
      }

      this.uploadImageUrl1 = "";

      for (var i = 1; i <= img_size; ++i) {
        var tmp_file = file[i - 1];
        if (tmp_file !== undefined && tmp_file !== null) {
          if (tmp_file.name.lastIndexOf(".") <= 0) {
            return;
          }
          const fr = new FileReader();
          fr.readAsDataURL(tmp_file);
          fr.addEventListener("load", () => {
            if (this.uploadImageUrl1 == "") {
              this.uploadImageUrl1 = fr.result;
              this.editedItem.imageData1 = fr.result;
              this.editedItem.img = new Date().getTime();
            }
          });
        }
      }
    },

    editItem(item) {
      this.editedIndex = this.list.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.dialog = true;
      this.input_image = null;
      //画像のロード

      if (item.img != "" && !item.img.match(/http/)) {
        this.uploadImageUrl1 =
          "https://tool-test.matomeroyal.com/wp-content/themes/tool/appmediaTool/appCalendar/icon/" +
          item.img;
      } else if (item.img.match(/http/)) {
        this.uploadImageUrl1 = item.img;
      } else {
        this.uploadImageUrl1 = "";
      }

      // this.loadImg(item);
    },

    //画像の拡大表示
    scaleImg(img_data) {
      if (img_data != "") {
        this.uploadImageUrl_scallview = img_data;
        this.imgDialog = true;
      }
    },
    closeScaleDialog() {
      this.imgDialog = false;
    },

    changeStatus(item) {
      this.editedIndex = this.list.indexOf(item);
      this.save(item);
    },

    apply() {
      var self = this;
      self.confirm_dialog = false;

      this.overlay = true;
      axios
        .post(process.env.VUE_APP_CALENDAR_APPLY, {
          data: null,
        })
        .then(function(response) {
          console.log(response);
          alert("CSVアップロードしました。");
          // self.close();
        })
        .finally(function() {
          self.overlay = false;
          self.honban_flg = false;
        });
    },

    save(item) {
      this.overlay = true;
      //カテゴリIDを取得
      var saveData = Object.assign({}, item);

      if (saveData.release == "" || saveData.release == null) {
        alert("リリース日を入力してください");
        return;
      }
      if (saveData.title == "" || saveData.title == null) {
        alert("タイトルを入力してください");
        return;
      }

      saveData.category_id = saveData.category ? saveData.category.id : 0;

      if (saveData.category_id == "" || saveData.category_id == 0) {
        alert("カテゴリを選択してください");
        return;
      }

      //ステータスIDを取得
      saveData.status = saveData.status ? saveData.status.id : 0;

      var self = this;
      axios
        .post(process.env.VUE_APP_CALENDAR_UPDATE, {
          data: saveData,
        })
        .then(function(response) {
          //新規追加
          if (response.data["status"] == 1) {
            if (saveData.category_id == self.select_category.id) {
              item.id = response.data["last_id"];
              var status = self.status_list.filter((e) => e.id == 0);
              item.status = status[0];
              self.list.unshift(item);
            }
            self.honban_flg = true;
            self.close();
            //更新
          } else if (response.data["status"] == 2) {
            if (saveData.category_id == self.select_category.id) {
              Object.assign(self.list[self.editedIndex], item);
            } else {
              const index = self.list.indexOf(item);
              self.list.splice(index, 1);
            }

            self.honban_flg = true;
            self.close();
          } else if (response.data["status"] == 0) {
            console.log("更新なし");
            self.close();
          } else {
            alert("更新失敗しました！");
          }
        })
        .finally(function() {
          self.overlay = false;
        });
    },

    //削除
    deleteItem(item) {
      console.log(item);
      // var result = confirm("選択したデータを削除しますか？");
      // if (result == false) {
      //   return;
      // }

      // var self = this;
      // axios
      //   .post(process.env.VUE_APP_ENGINEER_WORK_DELETE, {
      //     data: item,
      //   })
      //   .then(function(response) {
      //     if (response.data["status"] == "success") {
      //       const index = self.list.indexOf(item);
      //       self.list.splice(index, 1);
      //     } else {
      //       alert("更新失敗・・！");
      //       console.log(response.data);
      //     }
      //     self.close();
      //   });
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 100);
    },

    newItem() {
      this.dialog = true;
      this.editedIndex = -1;
      this.uploadImageUrl1 = "";
      this.input_image = null;
      this.editedItem = Object.assign(
        {},
        {
          id: -1,
          category: "",
          title: "",
          sub_title: "",
          link: "",
          publisher: "",
          desc: "",
          precede_report: "",
          play_movie: "",
          img: "",
          question_id: 0,
          sort: 0,
          status: 0,
        }
      );
    },

    listchange() {
      this.getCalendarList();
    },

    getCalendarList() {
      axios
        .get(process.env.VUE_APP_CALENDAR_LIST, {
          params: { category: this.select_category.id },
        })
        .then((response) => {
          // v-data-tableを使うときは配列に格納する
          const items = [];
          const values = Object.values(response.data);

          values.forEach((value) => {
            //カテゴリをobject形式に(selectで利用)
            var category_item = this.category_list.filter(
              (e) => e.id == value.category_id
            );
            //ステータスをobject形式に(selectで利用)
            var status = this.status_list.filter((e) => e.id == value.status);

            // const category_item = {
            //   id: value.category_id,
            //   title: this.category_list[value.category_id].title,
            // };

            const item = {
              id: value.id,
              category: category_item[0],
              title: value.title,
              sub_title: value.sub_title,
              link: value.link,
              release: value.release,
              publisher: value.publisher,
              desc: value.desc,
              precede_report: value.precede_report,
              play_movie: value.play_movie,
              img: value.img,
              question_id: value.question_id,
              sort: value.sort,

              status: status[0],
            };
            items.push(item);
          });
          this.list = items;

          // console.log(this.list);
        });
    },

    refreshConfirm() {
      alert("DDDD");
    },

    //アンケート登録&取得
    getQuestion(item) {
      if (item.question_id != 0) {
        this.doCopy(item.question_id);
        return;
      }

      //カテゴリIDを取得
      this.overlay = true;
      var saveData = Object.assign({}, item);
      saveData.category_id = saveData.category ? saveData.category.id : 0;
      var self = this;
      //ステータスIDを取得
      saveData.status = saveData.status ? saveData.status.id : 0;
      axios
        .post(process.env.VUE_APP_POST_QUESTION, {
          data: saveData,
        })
        .then((response) => {
          // v-data-tableを使うときは配列に格納する
          console.log(response);
          if (response && response.data && response.data.status == "2") {
            item.question_id = response.data.last_id;
            self.doCopy(item.question_id);
            console.log(item);
          }
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    doCopy(question_id) {
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(
            '[survey id="' +
              question_id +
              '" multiple="1" end_time="" twitter_check=0 twitter_tag="AppMedia,新作スマホゲームアンケート]'
          )
          .then(() => {
            alert(
              "ショートコードをコピーしました。そのまま記事に貼り付けてください"
            );
          })
          .catch((e) => {
            console.error(e);
          });
      } else {
        alert("ローカル環境はコピーは使えません！");
      }
    },
  },

  watch: {},

  created: function() {
    //再読み込みで確認アラートが表示される
    // window.addEventListener('beforeunload', this.refreshConfirm, true);
    // window.addEventListener('beforeunload', this.refreshConfirm, false);
  },

  beforeCreate: function() {
    //カテゴリ一覧取得
    axios.get(process.env.VUE_APP_CALENDAR_CATEGORY).then((response) => {
      const items = [];
      var first = true;
      const values = Object.values(response.data);
      values.forEach((value) => {
        const item = {
          id: value.id,
          title: value.title,
          sort: value.sort,
          delete_flg: value.delete_flg,
        };

        if (first) {
          this.select_category = item;
          first = false;
        }

        items.push(item);
      });
      this.category_list = items;

      //(カテゴリ一覧を取得した後に)新作カレンダー一覧を取得
      this.getCalendarList();
    });
  },
};
</script>

<style>
.custom_textarea textarea {
  line-height: 1.4 !important;
}

.v-content__wrap {
  overflow: scroll !important;
}

.content_header {
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;
  box-shadow: 0 1px 6px #bbb;
}

.router-link-active {
  text-decoration: none;
}

.v-navigation-drawer__content
  .v-list-group
  .v-list-group__header
  .v-list-item__icon.v-list-group__header__append-icon {
  min-width: 35px;
}

.custom_table table {
  /* border: solid 1px #000000 !important; */
  border-collapse: collapse !important;
}
.custom_table th {
  background: #f4f4f4;
}
.custom_table th,
.custom_table td {
  border: 1px solid #ddd;
}

.v-data-table td,
.v-data-table th {
  padding: 0 8px;
}

.batch {
  display: block;
  font-size: 11px;
  color: #fff;
  border-radius: 6px;
  font-weight: bold;
  padding: 2px 0;
}
.batch.site {
  background-color: #2196f3;
}
.batch.appli {
  background-color: #4caf50;
}
.v-data-table .os_custom_table tr,
.v-data-table .os_custom_table td {
  padding: 3px;
  height: auto;
  text-align: left;
  border: none !important;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 200px;
}
.v-data-table .os_custom_table td img {
  vertical-align: middle;
}

.img_preview {
  width: 48%;
  display: inline-block;
  overflow: hidden;
  max-height: 130px;
  margin: 3px;
  max-width: 130px;
}

.img_preview img {
  object-fit: cover;
  width: 130px;
  height: 130px;
}

textarea {
  font-size: 14px !important;
  padding: 12px 8px !important;
}

.saving {
  background: #afabab;
}
.public_item {
  background: #fff5f5;
}
.public {
  background: #fd7c7c;
  color: #fff !important;
}

.status_box {
  padding: 0;
  text-align: center;
}

.status_box .v-application .primary--text::before {
  color: #fff !important;
}
.status_box .v-icon.v-icon::before {
  color: #fff !important;
}

.status_box.v-select .v-select__selection--comma {
  color: #fff !important;
  text-align: center;
  margin: 0 auto;
  font-size: 13px;
  font-weight: bold;
}
.status_box.v-select.v-text-field input {
  display: none;
}

.v-menu__content {
  border-radius: 0;
}
.v-menu__content .v-list {
  border-radius: 0;
}

.center {
  text-align: center;
}

.disable_item {
  color: #aaa;
}

/* .v-btn {
  justify-content: left !important;
} */
</style>
